<div class="addon">
  <div *ngIf="service.addOnUrl === ''">
    {{'Messages.msgErrorTryAgain' | translate}}
  </div>
  <div [style]="styleHeight" *ngIf="service.addOnUrl !== ''">
    <object #objectFrame [data]="service.addOnUrl | safe: 'resourceUrl'" style="border: none; width: 100%; height: 100%;" autoHeight></object>
  </div>
</div>
